import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import Table from 'react-bootstrap/Table';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Card from 'react-bootstrap/Card';
import {Button} from '@material-ui/core';
import numeral from 'numeral';

import UITableUtils from "../util/UITableUtils";
import Utilities from "../util/Utilities";
import FavUtils from "../util/FavUtils";
import SPCalc from "../util/SPCalc";
import RespUtils from "../util/RespUtils";

import IRewardUtils from "./IRewardUtils";
import IUtils from "./IUtils";

class DelWeightedRewards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rewards: [],
    }
  }

  async componentDidMount() {
    let rewards = this.calcRewards();
    this.setState({rewards: rewards});
  }

  calcRewards() {
    let amounts = [10000, 20000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000, 40000000, 50000000];
    let durations = [0, 14, 30, 60, 91, 120, 150, 180, 210, 240, 270, 300, 350];
    let amountLabels = ["10k","20k","50k","100k","200k","300k","500k","1 Million","2 Million","5 Million","10 Million","20 Million","40 Million","50 Million"];

    let allData = [];
    let netApr = this.props.delegate.netApr;
    let rewardPercentPerDay = this.props.delegate.rewardPercentPerDay;
    for (let i = 0; i < amounts.length; i++) {
      let data = {};
      data.amount = amounts[i];
      data.amountLabel = amountLabels[i];

      for (let dIndex=0; dIndex < durations.length; dIndex++) {
        let duration = durations[dIndex];
        let suffix = duration;

        let weightedNetApr = netApr;
        if (dIndex != 0) {
          weightedNetApr = IRewardUtils.getWeightedApr(netApr, duration);
        }
        let rewardPercentPerDay = weightedNetApr/365;

        data["weightedNetApr" + suffix] = weightedNetApr.toFixed(3);
        data["rewardPercentPerDay" + suffix] = rewardPercentPerDay.toFixed(3);
        let reward = rewardPercentPerDay * data.amount/100;

        if (reward > 100) {
          data["rewardPerDay" + suffix] = numeral(reward).format('0');
        } else {
          data["rewardPerDay" + suffix] = numeral(reward).format('0[.]00');
        }
      }
      // data.duration = durations[i];
      // data.durationLabel = durationLabels[i];
      //
      // if (i == 0) {
      //   data.weightedNetApr = netApr;
      // } else {
      //   data.weightedNetApr = IRewardUtils.getWeightedApr(netApr, data.duration);
      // }
      //
      // data.rewardPercentPerDay = netApr/365;
      // data.rewardPerDay = IRewardUtils.getXDayDailyReward(data.rewardPercentPerDay, data.amount, data.duration)

      allData.push(data);
      // console.log(i, " - ", data);
    }

    return allData;
  }

  render() {
    var columns;
    if (RespUtils.isMobileView()) {
      columns = [
        {text: "Amount Staked / Duration", dataField: "amountLabel", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(45)},
        {text: "0", dataField: "rewardPerDay0", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
        {text: "91", dataField: "rewardPerDay91", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(18)},
        {text: "180", dataField: "rewardPerDay180", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(17)},
      ];
    } else if (RespUtils.isTabletView()) {
      columns = [
        {text: "Amount Staked / Duration", dataField: "amountLabel", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(30)},
        {text: "0", dataField: "rewardPerDay0", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "30", dataField: "rewardPerDay30", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "91", dataField: "rewardPerDay91", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "180", dataField: "rewardPerDay180", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "270", dataField: "rewardPerDay270", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
        {text: "350", dataField: "rewardPerDay350", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10)},
      ];
    } else {
      columns = [
        {text: "Amount Staked / Duration", dataField: "amountLabel", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(11)},
        {text: "0", dataField: "rewardPerDay0", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "14", dataField: "rewardPerDay14", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "30", dataField: "rewardPerDay30", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "60", dataField: "rewardPerDay60", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "91", dataField: "rewardPerDay91", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "120", dataField: "rewardPerDay120", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "150", dataField: "rewardPerDay150", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "180", dataField: "rewardPerDay180", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "210", dataField: "rewardPerDay210", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "240", dataField: "rewardPerDay240", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "270", dataField: "rewardPerDay270", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "300", dataField: "rewardPerDay300", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
        {text: "350", dataField: "rewardPerDay350", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(7)},
      ];
    }

    const options = {
      onlyOneExpanding: true
    };

    // <DelInline delegate={row} coinStat={this.state.coinStat} hermesInd={this.state.hermesInd} />
    const expandRow = {
      renderer: row => (
        <div>
          <table>
            <tbody>
              <tr>
                <th align="left">Amount Staked: </th>
                <td align="left"> {row.amountLabel}</td>
              </tr>
            </tbody>
          </table>
          <br/>
          <Table striped bordered size="sm" >
            <thead>
              <tr>
                <th>Duration</th>
                <th>Net Apr</th>
                <th>Reward % Per Day</th>
                <th>Reward Per Day</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left"> 0 days</td>
                <td align="left"> {row.weightedNetApr0}</td>
                <td align="left"> {row.rewardPercentPerDay0}</td>
                <td align="left"> {row.rewardPerDay0}</td>
              </tr>
              <tr>
                <td align="left"> 14 days</td>
                <td align="left"> {row.weightedNetApr14}</td>
                <td align="left"> {row.rewardPercentPerDay14}</td>
                <td align="left"> {row.rewardPerDay14}</td>
              </tr>
              <tr>
                <td align="left"> 30 days</td>
                <td align="left"> {row.weightedNetApr30}</td>
                <td align="left"> {row.rewardPercentPerDay30}</td>
                <td align="left"> {row.rewardPerDay30}</td>
              </tr>
              <tr>
                <td align="left"> 60 days</td>
                <td align="left"> {row.weightedNetApr60}</td>
                <td align="left"> {row.rewardPercentPerDay60}</td>
                <td align="left"> {row.rewardPerDay60}</td>
              </tr>
              <tr>
                <td align="left"> 91 days</td>
                <td align="left"> {row.weightedNetApr91}</td>
                <td align="left"> {row.rewardPercentPerDay91}</td>
                <td align="left"> {row.rewardPerDay91}</td>
              </tr>
              <tr>
                <td align="left"> 120 days</td>
                <td align="left"> {row.weightedNetApr120}</td>
                <td align="left"> {row.rewardPercentPerDay120}</td>
                <td align="left"> {row.rewardPerDay120}</td>
              </tr>
              <tr>
                <td align="left"> 150 days</td>
                <td align="left"> {row.weightedNetApr150}</td>
                <td align="left"> {row.rewardPercentPerDay150}</td>
                <td align="left"> {row.rewardPerDay150}</td>
              </tr>
              <tr>
                <td align="left"> 180 days</td>
                <td align="left"> {row.weightedNetApr180}</td>
                <td align="left"> {row.rewardPercentPerDay180}</td>
                <td align="left"> {row.rewardPerDay180}</td>
              </tr>
              <tr>
                <td align="left"> 210 days</td>
                <td align="left"> {row.weightedNetApr210}</td>
                <td align="left"> {row.rewardPercentPerDay210}</td>
                <td align="left"> {row.rewardPerDay210}</td>
              </tr>
              <tr>
                <td align="left"> 240 days</td>
                <td align="left"> {row.weightedNetApr240}</td>
                <td align="left"> {row.rewardPercentPerDay240}</td>
                <td align="left"> {row.rewardPerDay240}</td>
              </tr>
              <tr>
                <td align="left"> 270 days</td>
                <td align="left"> {row.weightedNetApr270}</td>
                <td align="left"> {row.rewardPercentPerDay270}</td>
                <td align="left"> {row.rewardPerDay270}</td>
              </tr>
              <tr>
                <td align="left"> 300 days</td>
                <td align="left"> {row.weightedNetApr300}</td>
                <td align="left"> {row.rewardPercentPerDay300}</td>
                <td align="left"> {row.rewardPerDay300}</td>
              </tr>
              <tr>
                <td align="left"> 350 days</td>
                <td align="left"> {row.weightedNetApr350}</td>
                <td align="left"> {row.rewardPercentPerDay350}</td>
                <td align="left"> {row.rewardPerDay350}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      ), showExpandColumn: true
    };

    let lastUpdated = this.state.lastUpdated ? (this.state.lastUpdated/60).toFixed(0) : "N/A";
    let wrapperClasses = UITableUtils.isDefaultView() ? "table":"table-responsive";

    return (
      <div>
        <hr/>
        <span><strong>Weighted Rewards</strong></span>
        <BootstrapTable keyField='amount' data={ this.state.rewards }
          columns={ columns } hover striped expandRow={ expandRow }
          expandableRow={ () => { return true; } } rowStyle={UITableUtils.getMainTableRowStyle}
          condensed noDataIndication="Table is Empty/Loading" wrapperClasses={wrapperClasses}
          />
      </div>
    );
  }
}

export default DelWeightedRewards;



// WEBPACK FOOTER //
// ./src/iotex/DelWeightedRewards.js